import { useDisclosure } from '@chakra-ui/react';
import type { Broker, NestedAutocompleteAddress, NestedHome, SellerIntentType } from '@habity/types';

export interface UseSellStepperModalOptions {
  initialAddress?: NestedAutocompleteAddress | null;
  initialBroker?: Broker | null;
  addressBroker?: Broker | null;
  intent: SellerIntentType;
  locationName?: string | null;
  leadName?: string;
  leadEmail?: string;
  leadPhone?: string;
  leadSourceId?: string;
  assignmentSourceId?: string;
  onComplete?: (home?: NestedHome) => void;
}

export function useSellStepperModal(options: UseSellStepperModalOptions) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return {
    isOpen,
    onOpen,
    onClose,
    modalProps: {
      ...options,
      isOpen,
      onClose,
    },
  };
}
